module.exports = __webpack_public_path__ + "img/track.ce0e8c61.png";